import { CodeOutlined } from '@ant-design/icons'
import { Switch } from 'antd'
import type { ComponentOutlineControlsProps } from './useComponentOutlineControls'

export type { ComponentOutlineControlsProps } from './useComponentOutlineControls'

export default function ComponentOutlineControls({
  componentOutlineEnabled,
  setComponentOutlineEnabled,
  antdComponentOutlineEnabled,
  setAntdComponentOutlineEnabled,
}: ComponentOutlineControlsProps) {
  return (
    <section data-testid="component-marker-card" className="rounded bg-white p-3 shadow-sm">
      <div className="rounded-lg bg-red-50 px-4 py-4">
        <div className="flex items-start justify-between gap-3">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-white text-xl text-red-500 shadow-sm">
            <CodeOutlined />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block text-base font-semibold leading-6 text-gray-800">组件标识</span>
            <span className="mt-1 block text-sm leading-6 text-gray-500">
              为带 data-c 标识的组件显示红色边框，悬停查看组件名称
            </span>
          </span>
          <Switch
            aria-label="组件标识"
            checked={componentOutlineEnabled}
            checkedChildren="标识"
            onChange={setComponentOutlineEnabled}
          />
        </div>
      </div>
      <div className="mt-2 rounded-lg bg-teal-50 px-4 py-4">
        <div className="flex items-start justify-between gap-3">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-white text-xl text-teal-500 shadow-sm">
            <CodeOutlined />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block text-base font-semibold leading-6 text-gray-800">Ant Design 组件标识</span>
            <span className="mt-1 block text-sm leading-6 text-gray-500">
              为 Ant Design 组件显示青绿色边框，悬停查看组件名称
            </span>
          </span>
          <Switch
            aria-label="Ant Design 组件标识"
            checked={antdComponentOutlineEnabled}
            checkedChildren="标识"
            onChange={setAntdComponentOutlineEnabled}
          />
        </div>
      </div>
    </section>
  )
}
